import { render, staticRenderFns } from "./itemInventory.vue?vue&type=template&id=5b475751&scoped=true&"
import script from "./itemInventory.vue?vue&type=script&lang=js&"
export * from "./itemInventory.vue?vue&type=script&lang=js&"
import style0 from "./itemInventory.vue?vue&type=style&index=0&id=5b475751&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b475751",
  null
  
)

export default component.exports